import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Label, FormText, FormFeedback, Input } from 'reactstrap';
import styled from "styled-components";

const ExpenseEditingPanelDiv = styled.div`
position: relative;
    width: 300px;
    margin: 1em 1em 1em 1em;
`;

class ExpenseEditingPanel extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    
    render () {
      return (<ExpenseEditingPanelDiv>
          Editing Panel


          
        <Form >
            <FormGroup>
                <Label for="expenseName">Expense Name</Label>
                <Input name="expenseName" id="expenseName"/>
                <FormText>Expense name that will appear on UI</FormText>
            </FormGroup>
            <FormGroup>
                <Label for="code">Expense Code</Label>
                <Input valid id="code"/>
                <FormFeedback valid>Sweet! that name is available</FormFeedback>
                <FormText>Expense code name</FormText>
            </FormGroup>
            <FormGroup check>
                <Label check>
                <Input type="checkbox" />{' '}
                Hidden?
                </Label>
            </FormGroup>
        </Form>
      </ExpenseEditingPanelDiv> );
      
    }
  }

  ExpenseEditingPanel.propTypes = {
    appController:  PropTypes.object.isRequired,
    // cellInfo: PropTypes.object.isRequired,
    // setCellValue: PropTypes.func.isRequired,
    // getCellValue: PropTypes.func.isRequired
  }
  
  export default ExpenseEditingPanel;